var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("minesweeper-cell " + (_vm.getClass()))},[(_vm.cell.isOpen && _vm.cell.bombCount)?_c('div',[_vm._v(" "+_vm._s(_vm.cell.bombCount)+" ")]):_vm._e(),(_vm.cell.isOpen && _vm.cell.hasBomb)?_c('div',[_vm._v(" 💩 ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }